export const MAX_PACKAGING_VOLUME_CM3 = 1_000_000_000

function formatVolumeToken(value: number): string {
  if (!Number.isFinite(value)) {
    return ''
  }
  if (Number.isInteger(value)) {
    return String(value)
  }
  const text = value.toFixed(4)
  return text.replace(/\.?0+$/, '')
}

function parseVolumeCm3Numeric(raw: string): number | null {
  let compact = raw.trim().replace(/\s/g, '')
  if (compact.length === 0) {
    return null
  }

  compact = compact.replace(',', '.')
  if (compact.startsWith('.')) {
    compact = `0${compact}`
  }
  if (/^\d+\.$/.test(compact)) {
    compact = compact.slice(0, -1)
  }
  if (!/^\d+(\.\d+)?$/.test(compact)) {
    return null
  }

  const value = Number.parseFloat(compact)
  if (
    !Number.isFinite(value) ||
    value <= 0 ||
    value > MAX_PACKAGING_VOLUME_CM3
  ) {
    return null
  }

  return value
}

export function normalizePackagingItemVolumeCm3Field(
  raw: string
): string | null {
  const parsed = parseVolumeCm3Numeric(raw)
  if (parsed === null) {
    return null
  }
  return formatVolumeToken(parsed)
}

export function formatPackagingVolumeCm3ForInput(
  value: string | null | undefined
): string {
  if (value === null || value === undefined) {
    return ''
  }
  return value
}

export function parsePackagingVolumeCm3Input(value: string): string | null {
  const trimmed = value.trim()
  if (trimmed === '') {
    return null
  }
  return normalizePackagingItemVolumeCm3Field(trimmed)
}
